import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NavigationService } from '../../_services/navigation.service';
import { SecurityService } from '../../_services/security.service';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
  private navigation: string;
  private client: boolean = false;
  private transporter: boolean = false;
  private admin: boolean = false;
  private current_user = localStorage.getItem('current_user');

  constructor(
    private router: Router,
    private navigationService: NavigationService,
    private securityService: SecurityService,
    private userService: UserService) { }

  ngOnInit() {
    this.updateState();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateState();
        this.current_user = localStorage.getItem('current_user');
      }
    });
    
    this.navigationService.navigation$.subscribe((navState) => {
      this.navigation = navState;
    });

    this.userService.client$.subscribe(isClient => {
      this.client = isClient;
    });

    this.userService.transporter$.subscribe(isTransporter => {
      this.transporter = isTransporter;
    });

    this.userService.admin$.subscribe(isAdmin => {
      this.admin = isAdmin;
    });
  }

  switchNavigation(newNavigation: string): void {
    this.navigationService.setNavigation(newNavigation);
  }

  updateState() {
    this.navigation = this.navigationService.getNavigation() || 'side';

    if (this.client || this.transporter) {
      this.navigation = 'top';
      this.navigationService.setNavigation(this.navigation);
    }
  }

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  isTransportDetailsRoute(): boolean {
    return this.router.url.includes('/transport-details');
  }

  isDeliveryDetailsRoute(): boolean {
    return this.router.url.includes('/delivery-details');
  }
  
  isTransportInterestRoute(): boolean {
    return this.router.url.includes('/transport-interest');
  }

  logOut() {
    this.securityService.logout();
  }
    
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/navigation/navigation.component.ts